import React from 'react';
import { MetaTags } from 'react-meta-tags';
import { Col, Container, Row } from 'reactstrap';
import { Toaster } from 'react-hot-toast';
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import PremiumCareList from '../components/PremiumCareList';
import PremiumCareExportReport from '../components/PremiumCareExportReport';
import { EXPORT_ALLOWED_USER_ROLES } from '../../../constants/index';

const PremiumCareListIndex = () => {
  const users = JSON.parse(localStorage?.getItem('authUser'));

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Premium Care List</title>
        </MetaTags>
        <Container fluid>
          <Row className="align-items-center">
            <Col xl={4}>
              <DashBreadcrumb
                title="Premium Care"
                breadcrumbItem="Premium Care List"
              />
            </Col>
            <Col xl={8}>
              <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
                {EXPORT_ALLOWED_USER_ROLES.includes(String(users?.role_id)) && (
                  <div>
                    <PremiumCareExportReport />
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <PremiumCareList />
        </Container>
      </div>

      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};
export default PremiumCareListIndex;
